<template>
    <div class="page page-home">
    
        <Top></Top>

        <div class="hidden-xl hidden-lg navbar navbar-style-1">
            <div class="navbar-inner">
                <a v-on:click="$root.back()" class="link back">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z" fill="black"></path>
                    </svg>
                </a>
                <div class="title">Usuários</div>
                <div class="right">
                    <a style="opacity: 0;" class="link"> 
                        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.7 11.717C16.6839 10.9476 17.4031 9.89041 17.7575 8.69276C18.1118 7.49511 18.0836 6.21673 17.6767 5.03589C17.2698 3.85506 16.5046 2.83063 15.4877 2.10546C14.4708 1.38028 13.253 0.990524 12.004 0.990524C10.755 0.990524 9.53719 1.38028 8.52031 2.10546C7.50342 2.83063 6.73819 3.85506 6.33131 5.03589C5.92443 6.21673 5.89619 7.49511 6.25053 8.69276C6.60487 9.89041 7.32413 10.9476 8.308 11.717C6.44917 12.4566 4.85467 13.7363 3.73027 15.391C2.60587 17.0457 2.00318 18.9994 2 21V22C2 22.2652 2.10536 22.5196 2.29289 22.7071C2.48043 22.8946 2.73478 23 3 23H21C21.2652 23 21.5196 22.8946 21.7071 22.7071C21.8946 22.5196 22 22.2652 22 22V21C21.9975 19.0003 21.3959 17.0473 20.273 15.3927C19.1501 13.7381 17.5573 12.4579 15.7 11.717ZM8 7C8 6.20887 8.2346 5.43551 8.67412 4.77772C9.11365 4.11992 9.73836 3.60723 10.4693 3.30448C11.2002 3.00173 12.0044 2.92252 12.7804 3.07686C13.5563 3.2312 14.269 3.61216 14.8284 4.17157C15.3878 4.73098 15.7688 5.44371 15.9231 6.21964C16.0775 6.99556 15.9983 7.79983 15.6955 8.53073C15.3928 9.26163 14.8801 9.88635 14.2223 10.3259C13.5645 10.7654 12.7911 11 12 11C10.9391 11 9.92172 10.5786 9.17157 9.82842C8.42143 9.07828 8 8.06086 8 7ZM4 21C4 18.8783 4.84285 16.8434 6.34315 15.3431C7.84344 13.8428 9.87827 13 12 13C14.1217 13 16.1566 13.8428 17.6569 15.3431C19.1571 16.8434 20 18.8783 20 21H4Z" fill="#000"></path>
                        </svg>
                    </a>
                </div>
            </div>
        </div>
        
        <div class="page-content pt-30">

            <div class="container hidden-xs hidden-md">
                <h2>Usuários</h2>
            </div>

            <div class="container mt-30">
                <button v-on:click="$root.go('CadastrarUsuarios')" type="button" class="button button-outline mb-0">
                    <i class="las la-plus"></i>
                    Adicionar usuário
                </button>
            </div>
            <div class="container">
                
                <form v-if="$root.user.tipo != 'contratante'" onsubmit="return false" class="filtro" v-on:submit.prevent="form.page=1; get(true);">
                    <div class="list mb-20" style="margin-top: 0px">
                        <ul class="row">
                            <li class="item-content item-input col-100" style="padding-right: 0px !important; padding-left: 0px !important;">
                                <div class="item-inner" style="padding-left: 0px !important; padding-right: 0px !important;">
                                    <button type="button" v-on:click="mostrarFiltro" class="button button-outline color-gray" style="width: 100%; display: block">
                                        <i class="las la-filter" v-if="!filtro"></i>
                                        <i class="las la-chevron-up" v-if="filtro"></i> Filtrar
                                    </button>
                                </div>
                            </li>                                                            
                            <li v-if="filtro" class="item-content item-input item-input-outline col-100" style="padding-left: 0px !important; padding-right: 0px !important;">
                                <div class="item-inner" style="padding-left: 0px !important; padding-right: 0px !important;">
                                    <div class="item-title item-label">Pesquise um usuário:</div>
                                    <div class="item-input-wrap">
                                        <input type="text" placeholder="Escreva aqui..." v-model="form.pesquisa" class="form-control">
                                        <span class="input-clear-button"></span>
                                    </div>
                                </div>                                
                            </li>   
                            <li v-if="filtro" class="item-content item-input item-input-outline col-100 " style="padding-left: 0px !important; padding-right: 0px !important;">
                                <div class="item-inner " style="padding-left: 0px !important; padding-right: 0px !important;">
                                    <div class="item-title item-label">Tipo de usuário:</div>
                                    <div class="item-input-wrap">
                                        <select class="form-control" v-model="form.tipo" name="tipo">                                  
                                            <option value="admin,contratante,prestador,entregador" selected>Todos</option>
                                            <option value="contratante">Cliente</option>
                                            <option value="prestador">Profissionais</option>
                                            <option value="admin">Administrador</option>
                                            <option value="desativados">Desativados</option>
                                        </select> 
                                    </div>
                                </div>
                            </li>                                                       
                            <li v-if="filtro" class="item-content item-input col-50" style="padding-right: 0px !important;">
                                <div class="item-inner" style="align-items: flex-start; padding-left: 0px !important;">
                                    <h5 style="display: block; line-height: 100%; margin-top: -5px; margin-bottom: 0px;">
                                        <span style="font-size: 14px">Total:</span><br>
                                        {{data.total}}
                                    </h5>
                                </div>
                            </li>
                            <li v-if="filtro" class="item-content item-input col-50" style="padding-right: 0px !important;">
                                <div class="item-inner" style="align-items: flex-end; padding-right: 0px !important;">

                                    <button type="button" v-on:click="get" class="button button-outline " style="width: auto; display: inline-block; float: right;">
                                        <i class="las la-sync-alt"></i> 
                                        Atualizar
                                    </button>
                                </div>
                            </li>                                                                                                                                      
                        </ul>
                    </div>
                </form>              

                <div class="empty" v-if="data.itens.length == 0 && data.loaded">
                    <center>
                        <img src="static/images/empty.png" style="width: 80%">
                        <p class="mt-0 pt-0">
                            <i class="las la-times"></i>
                            Nenhum resultado encontrado.
                        </p>
                    </center>
                </div>
            </div>            

             
            <div class="container notification-list" v-if="data.itens.length > 0 && data.loaded">
                <ul>
               
                    <li v-for="(item, index) in data.itens" :key="item.cod" v-bind:class="{'disabled': item.ativo != 1}">
                        <h6 class="item-title" style="margin-bottom: 6px;">
                            #{{item.id}}
                            <span style="top: -2px; position: relative; left: 5px">
                                
                                <div v-if="item.tipo == 'prestador'" class="chip color-yellow" style="margin: 0px; height: 20px;">
                                    <div class="chip-label" style="color: #000">Profissional</div>
                                </div>
                                <div v-if="item.tipo == 'entregador'" class="chip color-pink" style="margin: 0px; height: 20px;">
                                    <div class="chip-label" style="color: #fff">Entregador</div>
                                </div>

                                <div v-if="item.tipo == 'contratante'" class="chip color-blue" style="margin: 0px; height: 20px;">
                                    <div class="chip-label" style="color: #fff">Cliente</div>
                                </div>

                                <div v-if="item.tipo == 'admin'" class="chip color-black" style="margin: 0px; height: 20px;">
                                    <div class="chip-label" style="color: #fff">Administrador</div>
                                </div>                                  

                            </span>                        

                            <span class="item-time">
                                <i class="las la-clock"></i> {{item.datahora | formatDate}}
                            </span>
                        </h6>
                        <h6 class="item-title" style="margin-bottom: 6px;">
                            {{item.empresa || item.nome}}
                        </h6>
                        <div class="item-text" style="font-size: 13px; position: relative;">
                            <div v-if="item.ativo != 1" class="chip color-red" style="margin: 0px; height: 20px; margin-top: -5PX !important; margin-bottom: 5px">
                                <div class="chip-label" style="color: #fff">
                                    <i class="las la-ban"></i>
                                    Usuário desativado
                                </div>
                            </div>       
                            
                            

                            <div v-if="item.tipo == 'prestador' && item.empresa">
                                <b><i class="las la-dot-circle"></i> Responsável:</b> {{item.nome}}<br>
                            </div>

                            <div>
                                <b><i class="las la-dot-circle"></i> E-mail:</b> {{item.email}}<br>
                            </div>

                            <div>
                                <b><i class="las la-dot-circle"></i> Telefone:</b> {{item.telefone}}
                            </div>

                            <div v-if="item.dispositivo">
                                <b><i class="las la-dot-circle"></i> Dispositivo:</b> {{item.dispositivo}}
                            </div>

<!--                             <div v-if="item.tipo == 'prestador'">
                                <b><i class="las la-dot-circle"></i> Comissão:</b> {{item.comissao}}%
                            </div> -->
<!-- 
                            <span style="display: block; margin-top: 10px; text-align: right;" v-if="item.tipo == 'prestador' && item.confirmacao == 1">
                                <div class="chip color-orange" style="margin: 0px; height: 20px; border-bottom-right-radius: 0px !important; border-top-right-radius: 0px !important;">
                                    <div class="chip-label">
                                        Dívida: <b>R$ {{item.recargaValor | toMoney}}</b>
                                    </div>
                                </div>
                                <button v-bind:class="{'disabled': item.recargaValor == 0}" v-on:click="definirPago(item.cod, item.recargaValor)" type="button" class="button button-outline color-green" style="display: inline-block; width: auto; font-size: 12px; height: 20px; line-height: 16px; border-bottom-left-radius: 0px !important; border-top-left-radius: 0px !important; margin-left: -5px">Definir como pago</button>
                            </span>
 -->
                            <div style="margin-bottom: 10px"></div>


                            <button v-if="item.confirmacao == 1 && item.ativo == 1" v-on:click="del(item.cod);" type="button" class="button button-outline color-red" style="display: inline-block; width: auto; float: right; margin-top: 0px; font-size: 12px; margin-left: 5px; height: 20px; line-height: 16px; ">
                                Desativar
                            </button>
                            <button v-on:click="$root.go('EditarUsuariosGeral', JSON.stringify({'c': item.cod}))" class="button button-outline color-gray" style="display: inline-block; width: auto; float: right; margin-top: 0px; font-size: 12px; height: 20px; line-height: 16px; margin-left: 5px;">
                                Editar
                            </button>  
                            
                            <a v-if="item.ativo == 1 && item.confirmacao == 0" class="button button-fill button-round color-red" v-on:click="negar(item.cod)" style="display: inline-block; width: auto; float: right; margin-top: 0px; font-size: 12px; margin-left: 5px; height: 20px; line-height: 19px; ">
                                <ion-icon name="close-outline"></ion-icon>
                                Negar
                            </a>                               
                            
                            <a v-if="item.ativo == 1 && item.confirmacao == 0" class="button button-fill button-round color-green" v-on:click="aprovar(item.cod)" style="display: inline-block; width: auto; float: right; margin-top: 0px; font-size: 12px; margin-left: 5px; height: 20px; line-height: 19px; ">
                                <ion-icon name="checkmark-circle-outline"></ion-icon>
                                Aprovar
                            </a>


                            <div style="margin-bottom: 30px"></div>


                        </div>
                    </li>
                   

                </ul>

                <div class="block" style="text-align: center;" v-if="data.pages.length > 1">
                    
                    <span style="display: inline-block; " v-show="data.page > 1" v-on:click="form.page = (data.page - 1); get(true);">
                        <div class="chip color-white">
                            <div class="chip-label" style="color: #333 !important">
                                <i class="las la-arrow-left"></i>
                                Anterior
                            </div>
                        </div>
                    </span>                    
                    
                    <span style="display: inline-block; " v-show="data.page >= 1 && data.page < (data.pages.length)" v-on:click="form.page = (data.page + 1); get(true);">
                        <div class="chip color-white">
                            <div class="chip-label" style="color: #333 !important">
                                Próxima
                                <i class="las la-angle-right"></i>
                            </div>
                        </div>
                    </span>   

                    <br>     

                    <span style="display: inline-block; margin-right: 5px; margin-top: 5px;" v-for="(item, index) in data.pages" v-show="item.show">
                        <div class="chip " v-bind:class="{'color-primary': item.index == data.page, 'color-gray': item.index != data.page}" v-on:click="form.page = item.index; get(true);">
                            <div class="chip-label">
                                {{item.index}}
                            </div>
                        </div>
                    </span>                                                             
                
                </div>                
            </div>
        </div>
    </div>
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'
export default {
    name: 'Categorias',
    components: {
        'Toolbar': Toolbar,
        'Top': Top
    },          
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1] || "";
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + " " + time;
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        }        
    },    
    data () {
        var self                    = this;
        return {
            "filtro":               false,
            "loaded":               false,
            "data":                 {
                "pages":            [],
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "tipo":             self.$router.currentRoute.meta.options.tipo,
                "page":             1,
                "pesquisa":         ""
            }              
        }
    },
    methods: {
        mostrarFiltro: function() {
            var  self = this;
            self.filtro = (self.filtro ? false : true);            
            self.$forceUpdate();
        },            
        aprovar: function(cod) {
            console.log("aprovar()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja aprovar esse cadastro?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                form.acao               = "aprovar";
                loading.show();
                
                axios.put("api/usuarios.php", form)
                .then(response => {
                    console.log("aprovar() responde", response.data);
                    self.get();
                })
                .catch(error => {
                    console.log("aprovar() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },  
        negar: function(cod) {
            console.log("negar()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja negar esse cadastro?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                var motivo              = prompt("Informe o motivo:");
                if (!motivo)            return false;
                form.cod                = cod;
                form.acao               = "negar";
                form.texto              = motivo;
                loading.show();
                
                axios.put("api/usuarios.php", form)
                .then(response => {
                    console.log("negar() responde", response.data);
                    self.get();
                })
                .catch(error => {
                    console.log("negar() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },            
        definirPago: function(cod, valor) {
            console.log("definirPago()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja definir como pago?", function() {

                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "cod":          cod,
                    "acao":         "divida",
                    "valor":        valor
                };                

                loading.show();
                
                axios.put("api/usuarios.php", form)
                .then(response => {
                    console.log("finalizar() response", response)
                    loading.hide();
                  
                    self.get(true);
                  
                    // self.get(true);
                    // alert(response.data.message);
                })
                .catch(error => {
                    console.log("finalizar() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });

            });
        },        
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                axios.get("api/usuarios.php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    self.loaded = true;
                    loading.hide();
                    resolve(response.data.result);
                    self.$root.scrollTop();
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },      
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja desativar esse usuário?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                self.loading.del        = true;
                loading.show();
                
                axios.delete("api/usuarios.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.loading.del    = false;
                    self.get();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    self.loading.del    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        }        
    },
    activated: function() {
        var self = this;
        // self.$root.back();
        self.get();
    },
    mounted: function() {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
   
</style>



// WEBPACK FOOTER //
// src/components/Usuarios.vue